import { useState } from 'react';

const useFormValidation = () => {
    const [touched, setTouched] = useState({});
    const [errors, setErrors] = useState({});

    const validateField = (name, value, type) => {
        // Check for empty/null/undefined
        if (value === '' || value === null || value === undefined) {
            return 'This field is required';
        }
        // Check for numbers > 0
        if (type === 'number' && Number(value) <= 0) {
            return 'Value must be greater than 0';
        }
        // Check for numbers >= 0 (zero is allowed)
        if (type === 'numberGteZero' && Number(value) < 0) {
            return 'Value must be greater than or equal to 0';
        }
        return null;
    };

    const handleBlur = (name, value, type = 'text') => {
        setTouched(prev => ({ ...prev, [name]: true }));
        const error = validateField(name, value, type);
        setErrors(prev => ({ ...prev, [name]: error }));
    };

    const getFieldState = (name) => ({
        isInvalid: touched[name] && errors[name],
        errorMessage: touched[name] ? errors[name] : null
    });

    // Validate all fields at once - call before form submission
    // fields: array of { name, value, type } objects
    // Returns true if all valid, false if any errors
    const validateAll = (fields) => {
        const newTouched = {};
        const newErrors = {};
        let isValid = true;

        fields.forEach(({ name, value, type = 'number' }) => {
            newTouched[name] = true;
            const error = validateField(name, value, type);
            newErrors[name] = error;
            if (error) {
                isValid = false;
            }
        });

        setTouched(prev => ({ ...prev, ...newTouched }));
        setErrors(prev => ({ ...prev, ...newErrors }));

        return isValid;
    };

    // Check if there are any current errors
    const hasErrors = () => {
        return Object.values(errors).some(error => error !== null);
    };

    const resetValidation = () => {
        setTouched({});
        setErrors({});
    };

    return { handleBlur, getFieldState, validateAll, hasErrors, errors, touched, resetValidation };
};

export default useFormValidation;
